import React from 'react';
import styled from 'styled-components';
import {breakPoint} from '../styles/var';
import OuterLink from './OuterLink';
import ScrollLink from './ScrollLink';
import Img from './Img';

// images
import logo_1 from '../asset/img/05-9_01.png';
import logo_2 from '../asset/img/05-9_03.png';
import x from '../asset/img/05-9_02.png';
// import img_147 from '../asset/img/147.png';
// import img_151 from '../asset/img/151.png';
// import img_153 from '../asset/img/153.png';

const FooterStyles = styled.footer`
  position: relative;
  background-color: var(--white);
  .sponsor {
    padding-top: 8rem;;
    padding-bottom: 2rem;
    > span,
    a {
      margin-right: 2rem;
      &:last-child {
        margin-right: 0;
      }
    }
    .title {
      margin-bottom: 1rem;
    }
  }
  .group {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .bio {
    margin-right: auto;
    margin-left: auto;
  }
  @media (max-width: ${breakPoint.max}) {
    .logo-1 {
      max-width: 14rem;
    }
    .logo-2 {
      max-width: 11rem;
    }
    .x {
      max-width: 2rem;
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    padding-top: 4rem;
    .sponsor {
      padding: 0 2rem 1.5rem;
      > span,
      a {
        margin-right: 1rem;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
`;

const CopyrightStyles = styled.div`
  --bg: var(--black);
  background-color: var(--bg);
  color: var(--white);
  padding: 1.5rem 2rem;
  @media (max-width: ${breakPoint.max}) {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  @media (max-width: ${breakPoint.smMax}) {
    span {
      display: block;
    }
  }
`;

const Footer = () => {
  return (
    <FooterStyles>
      <div className="sponsor group">
        <OuterLink href="https://www.mombaby.com.tw/">
          <Img src={logo_1} wrapProps={{className: 'logo-1'}} />
        </OuterLink>
        <span><Img src={x} wrapProps={{className: 'x'}} /></span>
        <ScrollLink to="header">
          <Img src={logo_2} wrapProps={{className: 'logo-2'}} />
        </ScrollLink>
      </div>
      <CopyrightStyles className="center">
        Copyright {new Date().getFullYear()}.媽媽寶寶 All rights reserved. <span>禁止擅自轉貼節錄</span>
      </CopyrightStyles>
    </FooterStyles>
  )
}

export default Footer;
